/** Error pages. */
const dictionary = {
  "en": {
    "notFound": {
      "title": "page not found",
      "backHome": "back to home page",
      "code": "404",
      "subtitle": "back to home page"
    }
  },
  "de": {
    "notFound": {
      "title": "Seite nicht gefunden",
      "backHome": "zurück zur Startseite",
      "code": "404",
      "subtitle": "zurück zur Startseite"
    }
  },
  "fi": {
    "notFound": {
      "title": "sivua ei löytynyt",
      "backHome": "takaisin etusivulle",
      "code": "404",
      "subtitle": "takaisin etusivulle"
    }
  }
};

export default dictionary;
